var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 77,
    viewBox: "0 0 82 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.1683 22.876C78.8575 20.5521 76.3581 19.7176 69.1421 16.9056C64.0009 14.9021 55.1604 18.8372 52.3545 23.767C51.7605 24.8107 50.3173 29.7103 49.9562 30.7853C49.6291 31.7593 48.8391 32.5695 48.4902 33.5288C48.2646 34.1489 49.0523 34.0439 50.125 34.8256C50.8865 35.3806 52.219 36.2738 53.2644 37.14C55.7824 39.2261 56.5717 38.343 58.8455 39.17C61.1193 39.9971 66.1812 39.6955 68.4377 38.6459C70.1417 37.8533 74.2185 35.0229 75.0944 33.1289C77.0495 28.9014 78.0742 23.778 78.1683 22.876Z",
    fill: "#FBE54D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1421 16.9056L69.596 15.7409L69.1421 16.9056ZM78.1683 22.876L76.9699 22.5206L76.937 22.6314L76.925 22.7464L78.1683 22.876ZM75.0944 33.1289L76.229 33.6536L75.0944 33.1289ZM68.4377 38.6459L67.9105 37.5125L68.4377 38.6459ZM53.2644 37.14L52.4669 38.1025L52.4669 38.1025L53.2644 37.14ZM52.3545 23.767L51.2681 23.1487L52.3545 23.767ZM49.9562 30.7853L51.1412 31.1833L49.9562 30.7853ZM50.125 34.8256L50.8612 33.8154L50.8612 33.8154L50.125 34.8256ZM68.6883 18.0703C72.3663 19.5036 74.6565 20.3664 75.9841 21.1502C76.6387 21.5367 76.883 21.8077 76.9715 21.9665C77.0209 22.0553 77.0706 22.1811 76.9699 22.5206L79.3667 23.2314C79.6106 22.4089 79.6063 21.559 79.1554 20.7498C78.7436 20.0107 78.0413 19.4616 77.2552 18.9974C75.7014 18.0801 73.1339 17.1196 69.596 15.7409L68.6883 18.0703ZM76.925 22.7464C76.8438 23.5254 75.8517 28.5136 73.9599 32.6042L76.229 33.6536C78.2473 29.2893 79.3047 24.0306 79.4115 23.0056L76.925 22.7464ZM73.9599 32.6042C73.8302 32.8847 73.5282 33.2957 73.0307 33.8046C72.5497 34.2965 71.9507 34.8149 71.3092 35.3137C70.0118 36.3227 68.6485 37.1693 67.9105 37.5125L68.9649 39.7793C69.9309 39.33 71.458 38.365 72.844 37.2872C73.5443 36.7426 74.2352 36.1487 74.8182 35.5524C75.3846 34.9731 75.9207 34.3201 76.229 33.6536L73.9599 32.6042ZM67.9105 37.5125C66.9943 37.9387 65.35 38.2638 63.5778 38.3637C61.798 38.464 60.1685 38.3211 59.2728 37.9953L58.4182 40.3447C59.7963 40.846 61.8346 40.9659 63.7184 40.8597C65.6097 40.7532 67.6245 40.4028 68.9649 39.7793L67.9105 37.5125ZM59.2728 37.9953C58.0084 37.5354 56.9297 37.4981 56.368 37.3969C55.807 37.2959 55.1745 37.0992 54.0619 36.1774L52.4669 38.1025C53.8723 39.2669 54.8935 39.6717 55.925 39.8574C56.9559 40.043 57.4088 39.9776 58.4182 40.3447L59.2728 37.9953ZM53.4409 24.3853C54.6622 22.2395 57.3078 20.1732 60.3578 18.8883C63.4253 17.596 66.553 17.2382 68.6883 18.0703L69.596 15.7409C66.59 14.5695 62.7268 15.1775 59.3872 16.5844C56.0302 17.9986 52.8526 20.3648 51.2681 23.1487L53.4409 24.3853ZM49.6649 33.9561C49.7839 33.6289 49.9862 33.3059 50.2867 32.8325C50.5573 32.4062 50.9218 31.8365 51.1412 31.1833L48.7713 30.3873C48.6635 30.7081 48.4694 31.0306 48.1761 31.4926C47.9126 31.9077 47.5454 32.4694 47.3155 33.1015L49.6649 33.9561ZM51.1412 31.1833C51.3208 30.6483 51.7945 29.085 52.2577 27.6479C52.4962 26.908 52.7386 26.1797 52.9559 25.5765C53.1854 24.9397 53.3538 24.5383 53.4409 24.3853L51.2681 23.1487C51.0582 23.5176 50.8234 24.12 50.604 24.729C50.3724 25.3716 50.12 26.1311 49.8783 26.8809C49.3811 28.4233 48.9526 29.8473 48.7713 30.3873L51.1412 31.1833ZM54.0619 36.1774C52.9778 35.2792 51.5592 34.3242 50.8612 33.8154L49.3888 35.8358C50.2138 36.4371 51.4602 37.2684 52.4669 38.1025L54.0619 36.1774ZM50.8612 33.8154C50.2084 33.3397 49.5564 33.0855 49.3725 32.995C49.3189 32.9686 49.3197 32.9656 49.3432 32.9821C49.3676 32.9992 49.4583 33.0659 49.5441 33.1964C49.6409 33.3436 49.6949 33.5162 49.7009 33.6865C49.7062 33.8371 49.6722 33.9359 49.6649 33.9561L47.3155 33.1015C47.1799 33.4742 47.103 34.0343 47.4551 34.5698C47.7205 34.9735 48.1255 35.1677 48.2689 35.2382C48.6907 35.4457 48.9688 35.5298 49.3888 35.8358L50.8612 33.8154Z",
    fill: "#351771"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7662 20.3351C54.8513 28.1166 57.3886 52.0344 53.9888 60.901C52.2609 65.4073 48.5702 64.4235 45.1547 65.3387C41.9178 66.206 39.3231 68.8837 35.6025 65.8276C27.6723 59.3137 17.0715 35.8732 14.9311 27.8849C11.7863 16.1486 21.9485 19.2755 32.0843 16.5596C42.2202 13.8437 49.6215 8.59888 52.7662 20.3351Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3428 15.0226C51.771 16.6206 50.2221 20.4993 44.2056 21.2277C37.7192 24.0661 34.4585 26.2761 29.8429 27.5128C19.707 30.2287 15.4238 27.7918 14.6376 24.8578C13.8514 21.9237 21.4308 17.3435 31.5667 14.6276C41.7026 11.9117 50.5566 12.0886 51.3428 15.0226Z",
    fill: "#FBE54D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8429 27.5128C19.707 30.2287 15.4238 27.7918 14.6376 24.8578C13.8514 21.9237 21.4308 17.3435 31.5667 14.6276C41.7026 11.9117 50.5566 12.0886 51.3428 15.0226C51.771 16.6206 50.2221 20.4993 44.2056 21.2277M29.8429 27.5128C34.4585 26.2761 37.7192 24.0661 44.2056 21.2277M29.8429 27.5128L44.2056 21.2277",
    stroke: "#351771",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7916 7.93745C28.748 6.35098 27.6245 15.0199 27.8182 19.5527C32.7577 20.1192 43.5084 21.1958 46.9951 20.9691C51.3535 20.6858 50.7723 14.4533 50.7723 13.0368C50.7723 11.6203 47.5762 3.68795 44.3801 2.27146C41.1839 0.854976 42.3462 5.38774 42.6367 6.52093C42.9273 7.65412 42.3461 9.92053 34.7916 7.93745Z",
    fill: "#FFF18F",
    fillOpacity: 0.9,
    stroke: "#351771",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4053 21.7297C18.5969 22.4821 8.2981 33 35.2981 26L47.2981 21C53.2981 16 44.4472 16.7459 37.7981 18C31.149 19.2541 23.3842 10.1296 22.0544 7.62142C20.7246 5.11327 21.5225 11.0701 18.0649 10.1296C14.6074 9.18902 11.6818 11.0701 12.7456 12.6377C13.8095 14.2053 14.3414 15.4593 12.7456 16.3999C11.1499 17.3404 6.36253 16.3999 5.8306 19.8486C5.29867 23.2973 11.4159 20.7891 15.4053 21.7297Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42791 52.7319C5.73866 50.408 8.23812 49.5735 15.4541 46.7616C20.5953 44.7581 29.4358 48.6932 32.2417 53.623C32.8357 54.6666 34.2789 59.5663 34.64 60.6413C34.9671 61.6153 35.7571 62.4254 36.106 63.3848C36.3316 64.0049 35.5439 63.8998 34.4712 64.6816C33.7097 65.2366 32.3772 66.1298 31.3318 66.9959C28.8138 69.0821 28.0245 68.1989 25.7507 69.026C23.4769 69.8531 18.415 69.5515 16.1585 68.5019C14.4545 67.7093 10.3776 64.8788 9.50175 62.9849C7.54669 58.7574 6.52196 53.634 6.42791 52.7319Z",
    fill: "#FBE54D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4541 46.7616L15.0002 45.5969L15.4541 46.7616ZM6.42791 52.7319L7.62631 52.3765L7.65919 52.4873L7.67117 52.6023L6.42791 52.7319ZM9.50175 62.9849L8.36721 63.5096L9.50175 62.9849ZM16.1585 68.5019L16.6857 67.3685L16.1585 68.5019ZM31.3318 66.9959L32.1293 67.9585L32.1293 67.9585L31.3318 66.9959ZM32.2417 53.623L33.328 53.0047L32.2417 53.623ZM34.64 60.6413L33.455 61.0392L34.64 60.6413ZM34.4712 64.6816L33.735 63.6714L33.735 63.6714L34.4712 64.6816ZM15.9079 47.9263C12.2299 49.3595 9.93968 50.2223 8.61206 51.0062C7.95752 51.3926 7.71318 51.6637 7.62468 51.8225C7.57525 51.9112 7.52564 52.0371 7.62631 52.3765L5.22951 53.0874C4.98556 52.2649 4.98991 51.4149 5.44077 50.6057C5.85257 49.8666 6.55486 49.3176 7.34102 48.8534C8.89481 47.936 11.4623 46.9756 15.0002 45.5969L15.9079 47.9263ZM7.67117 52.6023C7.7524 53.3814 8.74452 58.3695 10.6363 62.4602L8.36721 63.5096C6.34886 59.1452 5.29151 53.8865 5.18465 52.8616L7.67117 52.6023ZM10.6363 62.4602C10.766 62.7407 11.0679 63.1517 11.5655 63.6606C12.0465 64.1525 12.6455 64.6708 13.287 65.1697C14.5844 66.1787 15.9477 67.0252 16.6857 67.3685L15.6313 69.6353C14.6653 69.1859 13.1382 68.221 11.7522 67.1431C11.0519 66.5985 10.361 66.0046 9.77801 65.4084C9.21158 64.8291 8.67545 64.1761 8.36721 63.5096L10.6363 62.4602ZM16.6857 67.3685C17.6018 67.7946 19.2462 68.1198 21.0184 68.2197C22.7982 68.3199 24.4277 68.1771 25.3234 67.8513L26.178 70.2007C24.7999 70.702 22.7616 70.8218 20.8778 70.7157C18.9865 70.6091 16.9716 70.2587 15.6313 69.6353L16.6857 67.3685ZM25.3234 67.8513C26.5878 67.3914 27.6665 67.354 28.2282 67.2529C28.7892 67.1519 29.4217 66.9551 30.5343 66.0334L32.1293 67.9585C30.7239 69.1229 29.7027 69.5276 28.6711 69.7133C27.6403 69.8989 27.1874 69.8335 26.178 70.2007L25.3234 67.8513ZM31.1553 54.2413C29.934 52.0954 27.2884 50.0291 24.2384 48.7442C21.1709 47.452 18.0432 47.0942 15.9079 47.9263L15.0002 45.5969C18.0062 44.4255 21.8694 45.0335 25.2089 46.4403C28.566 47.8546 31.7436 50.2208 33.328 53.0047L31.1553 54.2413ZM34.9313 63.8121C34.8123 63.4849 34.61 63.1618 34.3095 62.6885C34.0389 62.2621 33.6744 61.6925 33.455 61.0392L35.8249 60.2433C35.9327 60.5641 36.1268 60.8865 36.4201 61.3486C36.6836 61.7636 37.0508 62.3253 37.2807 62.9575L34.9313 63.8121ZM33.455 61.0392C33.2753 60.5042 32.8017 58.941 32.3385 57.5039C32.1 56.7639 31.8576 56.0356 31.6403 55.4325C31.4108 54.7957 31.2424 54.3942 31.1553 54.2413L33.328 53.0047C33.538 53.3735 33.7728 53.9759 33.9922 54.5849C34.2238 55.2276 34.4762 55.9871 34.7179 56.7369C35.2151 58.2793 35.6436 59.7033 35.8249 60.2433L33.455 61.0392ZM30.5343 66.0334C31.6184 65.1352 33.0369 64.1801 33.735 63.6714L35.2074 65.6918C34.3824 66.2931 33.136 67.1244 32.1293 67.9585L30.5343 66.0334ZM33.735 63.6714C34.3878 63.1957 35.0398 62.9414 35.2237 62.851C35.2773 62.8246 35.2765 62.8216 35.253 62.8381C35.2286 62.8552 35.1379 62.9219 35.0521 63.0524C34.9553 63.1996 34.9013 63.3722 34.8953 63.5424C34.89 63.6931 34.924 63.7919 34.9313 63.8121L37.2807 62.9575C37.4163 63.3301 37.4932 63.8903 37.1411 64.4258C36.8757 64.8295 36.4707 65.0236 36.3272 65.0942C35.9055 65.3017 35.6273 65.3858 35.2074 65.6918L33.735 63.6714Z",
    fill: "#351771"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 30.1323 66.0842)",
    fill: "#351771"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 33.7358 60.5676)",
    fill: "#351771"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 32.4219 62.7173)",
    fill: "#351771"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 31.4937 62.374)",
    fill: "#351771"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 32.4683 61.1538)",
    fill: "#351771"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 31.5413 60.8132)",
    fill: "#351771"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 33.4426 59.9336)",
    fill: "#351771"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 32.5159 59.593)",
    fill: "#351771"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 31.6365 57.6919)",
    fill: "#351771"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 34.0303 61.2041)",
    fill: "#351771"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 34.6628 60.9082)",
    fill: "#351771"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 33.6882 62.1282)",
    fill: "#351771"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 34.2744 63.3958)",
    fill: "#351771"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 33.9338 64.3228)",
    fill: "#351771"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 34.9561 61.5422)",
    fill: "#351771"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 34.3696 60.2744)",
    fill: "#351771"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 34.6165 62.4717)",
    fill: "#351771"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 29.3469 61.0586)",
    fill: "#351771"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.698289,
    cy: 0.698289,
    r: 0.698289,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 36.176 62.5166)",
    fill: "#351771"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 33.3477 63.0552)",
    fill: "#351771"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 35.2026 63.7393)",
    fill: "#351771"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 29.9331 62.3262)",
    fill: "#351771"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 33.0081 63.9849)",
    fill: "#351771"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 32.0801 63.6414)",
    fill: "#351771"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 30.6145 60.4724)",
    fill: "#351771"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 30.9551 59.5454)",
    fill: "#351771"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 30.0283 59.2048)",
    fill: "#351771"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 31.2957 58.6184)",
    fill: "#351771"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 32.8564 58.6663)",
    fill: "#351771"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 35.249 62.1758)",
    fill: "#351771"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 30.8125 64.2275)",
    fill: "#351771"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 31.1057 64.8613)",
    fill: "#351771"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 34.9082 63.1028)",
    fill: "#351771"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 34.322 61.835)",
    fill: "#351771"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 33.9814 62.762)",
    fill: "#351771"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 34.5676 64.0295)",
    fill: "#351771"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 33.6406 63.689)",
    fill: "#351771"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.349144,
    cy: 0.349144,
    r: 0.349144,
    transform: "matrix(-0.907639 0.419752 0.419752 0.907639 33.3 64.6157)",
    fill: "#351771"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06144 51.2108C7.01072 51.8479 7.11374 52.4863 6.58925 52.1957C6.33373 52.0541 5.66847 51.8743 4.92367 51.0953C4.40334 50.7095 3.76997 50.3186 3.4352 49.5872C2.79279 48.1837 2.89518 46.2016 3.38406 46.4284C5.22453 47.2824 6.15904 48.2506 6.62661 49.1086C7.12729 50.0274 7.09255 50.8199 7.06144 51.2108Z",
    fill: "#351771"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91233 52.2136C6.93896 51.6578 7.06849 51.1455 6.69028 51.2395C6.50603 51.2853 6.04424 51.2442 5.47237 51.6887C5.08789 51.8648 4.62738 52.0121 4.3341 52.5358C3.77133 53.5406 3.65144 55.254 3.99979 55.2038C5.3112 55.0148 6.02786 54.4649 6.42194 53.8724C6.84392 53.2379 6.896 52.5547 6.91233 52.2136Z",
    fill: "#351771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderStep4);
export default __webpack_public_path__ + "static/media/loader-step-4.cf222aab34fb476e0475c1413e8ef835.svg";
export { ForwardRef as ReactComponent };